const MEASUREMENT_ID = process.env.VUE_APP_GA_MEASUREMENT_ID || ''
const CONSENT_STORAGE_KEY = 'ga_consent'

const enabled = Boolean(MEASUREMENT_ID)
let initialized = false

function pushGtag(...args) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(args)
}

function loadScript() {
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
  document.head.appendChild(script)
}

function getStoredConsent() {
  try {
    return localStorage.getItem(CONSENT_STORAGE_KEY)
  } catch {
    return null
  }
}

function storeConsent(value) {
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, value)
  } catch {
    // localStorage unavailable (private mode, etc.) - consent banner will just re-show
  }
}

const AnalyticsService = {
  isEnabled() {
    return enabled
  },

  hasStoredConsent() {
    return getStoredConsent() !== null
  },

  init() {
    if (!enabled || initialized) {
      return
    }
    initialized = true

    const storedConsent = getStoredConsent()
    pushGtag('consent', 'default', {
      analytics_storage: storedConsent === 'granted' ? 'granted' : 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      wait_for_update: 500
    })

    loadScript()
    pushGtag('js', new Date())
    pushGtag('config', MEASUREMENT_ID, { send_page_view: false })
  },

  grantConsent() {
    storeConsent('granted')
    if (!enabled) {
      return
    }
    pushGtag('consent', 'update', { analytics_storage: 'granted' })
  },

  denyConsent() {
    storeConsent('denied')
    if (!enabled) {
      return
    }
    pushGtag('consent', 'update', { analytics_storage: 'denied' })
  },

  trackPageView({ path, title } = {}) {
    if (!enabled) {
      return
    }
    pushGtag('event', 'page_view', {
      page_path: path,
      page_title: title,
      page_location: window.location.href
    })
  },

  trackEvent(name, params = {}) {
    if (!enabled) {
      return
    }
    pushGtag('event', name, params)
  },

  setUserProperties(properties = {}) {
    if (!enabled) {
      return
    }
    pushGtag('set', 'user_properties', properties)
  }
}

export default AnalyticsService
